import React from 'react';
import type { IconProps } from './IconPlus';

export const IconGlobe: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="10" cy="10" r="8" stroke={color} strokeWidth="1.5"/>
    <path d="M2 10H18M10 2C12 4.5 13 7.5 13 10C13 12.5 12 15.5 10 18M10 2C8 4.5 7 7.5 7 10C7 12.5 8 15.5 10 18" stroke={color} strokeWidth="1.5"/>
  </svg>
);
